if (!customElements.get('featured-video-sliders')) {
    class FeaturedVideoSliders extends HTMLElement {
        constructor() {
            super();
            this.slideInterval = null;
            this.animateInterval = 5000;
            this.currentIndex = 0;
            this.triggerWalk = 0;
            this.direction = null;
            this.sensivityThreshold = 150;
            this.marginLeftOffset =  30;
        }

        connectedCallback() {
            this.animateInterval = parseInt(this.dataset.slideInterval) * 1000;

            this.selectors = {
                buttons: this.querySelectorAll('.controller > .bullets > button'),
                slider: this.querySelector('.featured-video-slider'),
                slides: this.querySelectorAll('.featured-video-slider > .slide'),
                play: this.querySelector('#slider-play'),
                controller: this.querySelector('.controller')
            };

            this.selectors.controller.addEventListener('click', () => {
                if(!this.slideInterval) this.goToSlide();
            })
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (!this.slideInterval) this.goToSlide();
                    } else {
                        if (this.slideInterval) {
                            clearInterval(this.slideInterval);
                            this.slideInterval = null;
                        }
                    }
                });
            }, {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            });

            observer.observe(this);

            this.initDragScroll();
            this.initSlideClicks();
            if(window.innerWidth < 768) {
                this.marginLeftOffset = 30;
            } else {
                this.marginLeftOffset = 47;
            }
            window.addEventListener('resize', () => {
                if(window.innerWidth < 768) {
                    this.marginLeftOffset = 30;
                } else {
                    this.marginLeftOffset = 47;
                }
            })
        }

        initSlideClicks() {
            this.selectors.slides.forEach((slide) => {
                slide.addEventListener('click', (event) => {
                    if (event.target.closest('a, button')) return;

                    const selectedIndex = parseInt(slide.dataset.slideIndex, 10);
                    if (Number.isNaN(selectedIndex)) return;

                    const activeButton = this.querySelector('.controller > .bullets > button.active');
                    const activeIndex = activeButton ? Array.from(this.selectors.buttons).indexOf(activeButton) : -1;
                    if (selectedIndex === activeIndex) return;

                    this.currentIndex = selectedIndex;
                    this.goToSlide();
                });
            });
        }

        goToSlide() {
            this.selectors.buttons.forEach(btn => btn.classList.remove('in-active'));
            this.selectors.play.classList.remove('active');
     
            const slide = () => {
                const index = this.currentIndex;
                const sliderWidth = this.selectors.slider.clientWidth;
                const slideWidth = this.selectors.slides[index].offsetWidth;
                const viewportWidth = window.innerWidth;
                let offset = 0;
                if(index > 0) {
                    offset = (viewportWidth - slideWidth);
                    offset = offset - this.marginLeftOffset;
                }
                const scrollX = (sliderWidth * index) - offset;
                this.selectors.slider.scrollTo({ left: scrollX, behavior: 'smooth' });

                this.selectors.buttons.forEach(btn => btn.classList.remove('active'));
                this.selectors.buttons[index].classList.add('active');

                const video = this.selectors.slides[index].querySelector('video');
                if (video) {
                    video.muted = true;
                    video.playsInline = true;
                    video.loop = true;
                    if (video.paused) video.play().catch(() => {});
                }

                this.currentIndex = (index + 1) % this.selectors.buttons.length;
            };

            if (this.slideInterval) clearInterval(this.slideInterval);

            slide();
            this.slideInterval = setInterval(slide, this.animateInterval);
        }

        initDragScroll() {
            const slider = this.selectors.slider;
            let isDown = false;
            let startX;
            let scrollLeft;
            let lastX = 0;
          
            slider.style.cursor = 'grab';

            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
                lastX = startX;
                slider.style.cursor = 'grabbing';
                if(e.target.closest('.slide'))  {
                    this.currentIndex = parseInt(e.target.closest('.slide')?.dataset.slideIndex);
                } 
                e.preventDefault(); 
            });

            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.style.cursor = 'grab';
                slider.classList.remove('active');
            });

            const handleMouseUp = (e) => {
                isDown = false;
                slider.style.cursor = 'grab';
                slider.classList.remove('active');  
                const x = e.pageX - slider.offsetLeft;
                if (x < lastX) {
                    this.direction = 'right';

                } else if (x > lastX) {
                    this.direction = 'left';
                } 
                this.manualGoToSlide(e);
                lastX = x;
            };

            slider.addEventListener('mouseup', e => handleMouseUp(e));
            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();

                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 2;
                this.triggerWalk = walk < 0 ? -walk : walk;
                //slider.scrollLeft = scrollLeft - walk;
               
            });
            // ====== TOUCH EVENTS (for mobile) ======
            slider.addEventListener('touchstart', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.touches[0].pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
                lastX = startX;
                if(e.target.closest('.slide'))  {
                    this.currentIndex = parseInt(e.target.closest('.slide')?.dataset.slideIndex);
                }
            });

           slider.addEventListener('touchend', (e) => {
                isDown = false;
                slider.classList.remove('active');

                const x = e.changedTouches[0].pageX - slider.offsetLeft;
                this.direction = x < lastX ? 'right' : 'left';
                this.manualGoToSlide(e);
                lastX = x;
            });

            slider.addEventListener('touchmove', (e) => {
                if (!isDown) return;
                const x = e.touches[0].pageX - slider.offsetLeft;
                const walk = (x - startX) * 2;
                //slider.scrollLeft = scrollLeft - walk;
                this.triggerWalk = walk < 0 ? -walk : walk;
            });
        }
        
        manualGoToSlide() {
            if(this.triggerWalk > this.sensivityThreshold) {
                this.selectors.buttons.forEach(btn => btn.classList.remove('active'));
                this.selectors.buttons.forEach(btn => btn.classList.remove('in-active'));
                this.selectors.buttons[this.currentIndex].classList.add('in-active');
                this.selectors.play.classList.add('active');
                if(this.slideInterval) {
                    clearInterval(this.slideInterval);
                    this.slideInterval = null;
                }
            }
            if(this.triggerWalk > this.sensivityThreshold && this.direction === 'right' && this.currentIndex < 2) {
                this.currentIndex++;
            };
            if(this.triggerWalk > this.sensivityThreshold && this.direction === 'left' && this.currentIndex > 0) {
                this.currentIndex--;
            };
           
            const sliderWidth = this.selectors.slider.clientWidth;
            const slideWidth = this.selectors.slides[this.currentIndex].offsetWidth;
            const viewportWidth = window.innerWidth;
            let offset = 0;
            if(this.currentIndex > 0) {
                offset = (viewportWidth - slideWidth);
                offset = offset - this.marginLeftOffset;
            }   
            const scrollX = (sliderWidth * this.currentIndex) - offset;
            this.selectors.slider.scrollTo({ left: scrollX, behavior: 'smooth' });

            const video = this.selectors.slides[this.currentIndex].querySelector('video');
            if (video) {
                video.muted = true;
                video.playsInline = true;
                video.loop = true;
                if (video.paused) video.play().catch(() => {});
            }
            if(!this.slideInterval) this.goToSlide();
        }
    }

    customElements.define('featured-video-sliders', FeaturedVideoSliders);
}
